{
    "Profile_CommonComponents_Quotes.messagesHeader": "Important Messages",
    "Profile_CommonComponents_Quotes.taxesIncluded": "{estimatedAnnualGross} per year (taxes included)",
    "Profile_CommonComponents_Quotes.quoteNo": "Quote No: {referenceNumber}",
    "Profile_CommonComponents_Quotes.acceptQuote": "Accept Quote",
    "Profile_CommonComponents_Quotes.acceptingQuoteTitle": "Accepting a quote",
    "Profile_CommonComponents_Quotes.acceptingQuoteConfirmation": "Your documents will be sent to your broker to be processed. Are you sure?",
    "Profile_CommonComponents_Quotes.acceptingQuoteNotification": "You will be notified by email when they are ready to sign, as soon as possible.",
    "Profile_CommonComponents_Quotes.yes": "Yes",
    "Profile_CommonComponents_Quotes.cancel": "Cancel",
    "Profile_CommonComponents_Quotes.userCurrentChoice": "Applicant Choice"
}
